import { motion } from "framer-motion";
import { useContext } from "react";
import { isMobileContext } from "../context/isMobileContext";
const AwardsCard = ({ key, index, text, img,tabIndex }) => {
    const { isMobile } = useContext(isMobileContext);
    return (
        <motion.div
            initial={{ opacity: "0"}}
            animate={{ opacity: 1 }}
            exit={{opacity:0}}
            viewport={{ once: true }}
            transition={{ delay: .1, duration: .25}}
            className={`awards-card ${index === 0 && "before-line"}
            ${isMobile&&"mobile-card"}
            ${tabIndex===1&&index===3&&"full-width"}
            `}>
            <div className={`img-container`}>
                <img
                    src={img}
                    alt="card-img"
                />
            </div>
            <div className="text">{text}</div>
        </motion.div>
    )
}

export default AwardsCard
